import type { ListAnalytics } from 'analytics/types';

export const SEARCH_TYPE = 'shop-by-list';
export const SHOP_BY_LIST_PAGE_TITLE = 'Match my list';
export const SHOP_BY_LIST_VIEW_ALL_CTA_LABEL = 'View all';
export const SHOP_BY_LIST_VIEW_ALL_MODAL_NAME = 'view_all_list_to_basket';
export const SHOP_BY_LIST_VIEW_ALL_MODAL_ID = 'viewAllListToBasketModal';

export const SHOP_BY_LIST_TAKE_A_PHOTO_CTA_LABEL = 'Take a photo';
export const SHOP_BY_LIST_UPLOAD_IMAGE_CTA_LABEL = 'Upload image';
export const SHOP_BY_LIST_FORM_SUBMIT_CTA_LABEL = 'Find your items';
export const INITIAL_MAX_CANDIDATES_PER_TERM = 10;
export const VIEW_ALL_MODAL_MAX_CANDIDATES_PER_TERM = 48;
export const ADD_TO_LIST_INPUT_ID = 'shop-by-list-add-to-list-input';

export const LINK_TARGET_NEW_TAB = '_blank';

export const SHOP_BY_LIST_LIST_DEFINITIONS: ListAnalytics = {
  curation: 'Catalog',
  format: 'List',
  page: 'List to Basket',
  title: SHOP_BY_LIST_PAGE_TITLE,
};

export const SHOP_BY_LIST_CLICK_CONTEXT = {
  listDefinitions: SHOP_BY_LIST_LIST_DEFINITIONS,
};

export const SHOP_BY_LIST_VIEW_STATE_SUGGESTIONS = 'SHOP_BY_LIST_VIEW_STATE_SUGGESTIONS' as const;
export const SHOP_BY_LIST_VIEW_STATE_ADD_ALL_LOADING =
  'SHOP_BY_LIST_VIEW_STATE_ADD_ALL_LOADING' as const;

export type ShopByListViewState =
  | typeof SHOP_BY_LIST_VIEW_STATE_SUGGESTIONS
  | typeof SHOP_BY_LIST_VIEW_STATE_ADD_ALL_LOADING;
